import {
    formatDateToHuman,
} from '@/utils/date';

import { TimeEntry } from './types';

export const formatDateInterval = (dates: TimeEntry): string => {
    const start = formatDateToHuman(dates.start);
    const end = formatDateToHuman(dates.end);

    return `${start} - ${end}`;
}
